const listsAreEqual = (list1: Array<any>, list2: Array<any>): boolean => {
  const set1 = new Set(list1)
  const set2 = new Set(list2)

  return set1.size === set2.size && [...set1].every(value => set2.has(value))
}

export default listsAreEqual
